export function videoPlayer() {
    const videos = document.querySelectorAll(".video-wrap");
    [...videos].forEach(item => {
        const video = item.querySelector("video");
        const videoPoster = item.querySelector(".video-poster");
        const playBtn = item.querySelector(".play-btn");
        if (videoPoster) {
            playBtn.addEventListener("click", () => {
                videoPoster.classList.add("hidden");
                video.style.opacity = "1";
                video.play();
            });
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/videoPlayer.js